import { Button } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import Container from "@saleor/components/Container";
import PageHeader from "@saleor/components/PageHeader";
import useNavigator from "@saleor/hooks/useNavigator";
import useShop from "@saleor/hooks/useShop";
import { sectionNames } from "@saleor/intl";
import { ListProps } from "@saleor/types";
import createFilterHandlers from "@saleor/utils/handlers/filterHandlers";
import { canManageFulfillment } from "@saleor/utils/handlers/userHandler";
import * as React from "react";
import { useIntl } from "react-intl";

import { dispatchHistoryListUrl, DispatchListUrlQueryParams } from "../../url";
import FilterBar from "../DispatchHistoryFilterBar";
import { RiderDispatchBatches_riderDispatchBatches_edges_node } from "./../../types/RiderDispatchBatches";
import DispatchHistoryList from "./../DispatchHistoryList";
import {
  createFilterStructure,
  getFilterOpts,
  getFilterQueryParam
} from "./filters";

interface DispatchHistoryListPageProps extends ListProps {
  params: DispatchListUrlQueryParams;
  navToAssignRider: () => void;
  batches: RiderDispatchBatches_riderDispatchBatches_edges_node[];
}

const DispatchHistoryListPage: React.FC<DispatchHistoryListPageProps> = props => {
  const { params, navToAssignRider, ...listProps } = props;
  const intl = useIntl();
  const shop = useShop();
  const navigate = useNavigator();
  const currencySymbol = shop?.defaultCurrency || "PHP";

  const disableAction = !canManageFulfillment();

  const structure = createFilterStructure(intl, getFilterOpts(params));

  const [changeFilters] = createFilterHandlers({
    createUrl: dispatchHistoryListUrl,
    getFilterQueryParam,
    navigate,
    params
  });

  const handleSearch = (text: string) => {
    navigate(dispatchHistoryListUrl({ ...params, batchCode: text }));
  };

  return (
    <>
      <Container>
        <PageHeader title={intl.formatMessage(sectionNames.dispatchHistory)}>
          <Button
            variant="contained"
            color="primary"
            onClick={navToAssignRider}
            disabled={disableAction}
          >
            ASSIGN RIDER
          </Button>
        </PageHeader>
        <Card>
          {/* Filter Section Here */}
          <FilterBar
            currencySymbol={currencySymbol}
            filterStructure={structure}
            searchPlaceholder=""
            initialSearch=""
            onFilterChange={changeFilters}
            onSearchChange={handleSearch}
          />

          <DispatchHistoryList {...listProps} />
        </Card>
      </Container>
    </>
  );
};

export default DispatchHistoryListPage;
